module.exports = __webpack_public_path__ + "img/remove.defaab3b.svg";